import { Record } from '@redge-media/fo-js-sdk';
import { cover } from '@/shared/libs/helpers';

const VIDEO_TYPES = {
  MP4: 'video/mp4',
  OGG: 'video/ogg',
  WEBM: 'video/webm',
};

const Banner = Record.mixin(cover).extend({
  constructor: function Banner(attrs = [], opts = {}) {
    Record.call(this, attrs, opts);
  },

  get hasVideos() {
    return this.videos && this.videos.length > 0;
  },

  set(key, value, opts = {}) {
    const data = Record.prototype.set.call(this, key, value, opts);

    if (data.videos) {
      data.videos.forEach((video) => {
        video.type = VIDEO_TYPES[video.format];
      });
    }

    return data;
  },
});

export default Banner;
